import './midtermTransaction.scss';

import {
  CreateMidtermTransactionField,
  getMidtermTransactionFieldProps,
} from '@converge/data';

import { Box } from '@mui/material';
import { NewFormTextField } from '../../../../presentation/components';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';

export interface MidtermTransactionNoteProps {
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MidtermTransactionNote = ({
  setIsDisabled,
}: MidtermTransactionNoteProps) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const [notes] = watch([CreateMidtermTransactionField.notes]);

  useEffect(() => {
    const hasErrors = Object.keys(errors).length > 0;
    setIsDisabled(!notes || hasErrors);
  }, [notes, errors, setIsDisabled]);

  return (
    <>
      <Box className="context-midterm-transaction">
        Include as much detail as necessary for this midterm transaction.
      </Box>
      <Box>
        <NewFormTextField
          {...getMidtermTransactionFieldProps(
            CreateMidtermTransactionField.notes
          )}
          rows={10}
          multiline
          placeholder="Start your note"
          onChange={(e) => {
            setValue(CreateMidtermTransactionField.notes, e?.target.value);
            e.target.value.length > 0
              ? setIsDisabled(false)
              : setIsDisabled(true);
          }}
        />
      </Box>
    </>
  );
};
